import { render, staticRenderFns } from "./FollowUpload.vue?vue&type=template&id=51302dcc&scoped=true&"
import script from "./FollowUpload.vue?vue&type=script&lang=js&"
export * from "./FollowUpload.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpload.vue?vue&type=style&index=0&id=51302dcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51302dcc",
  null
  
)

export default component.exports